import React, { useRef, useState } from 'react'
import {
  View,
  Text,
  TextInput,
  ActivityIndicator
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import Card from '../../shared/card/Card'
import CustomButton from '../../shared/button/Button'
import { Formik } from 'formik'
import * as yup from 'yup'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import SelectKeyValue from '../../shared/form/SelectKeyValue'
import { mapSelectValue } from '../../../utils'
import { usePersonalStore } from '../../../stores/personalInfo'
import Toast from 'react-native-toast-message'
import { CheckBox } from 'react-native-elements'

const KyInformationForm = ({ navigation, route }: any): JSX.Element => {
  const formikRef = useRef(null)
  const { params } = route
  const {
    mostRecentUserOnBoardings: userId,
    mode,
    essUserOnBoardingKey,
    essUserOnBoardingFormKey
  } = params

  const options3 = [
    { key: 1, value: 'No' },
    { key: 2, value: 'Yes' }
  ]

  const options1 = [
    { key: 1, value: 'Single' },
    { key: 2, value: 'Married' },
    { key: 3, value: 'Married but withhold as single' }
  ]

  const intialValues = {
    incomeTaxLiabilityExpected: '',
    qualifyExcemptionCertificate: '',
    stateOfResident: '',
    qualifyNonresidentMilitarySpouseExcemption: '',
    workInKentucky: "",
    additionalWithholding: '',
    martialstatus: ""
  }
  const alschema = yup.object({
    incomeTaxLiabilityExpected: yup
      .string()
      .nullable(),
    qualifyExcemptionCertificate: yup
      .string()
      .nullable(),
    stateOfResident: yup.string().when("qualifyExcemptionCertificate", (qualifyExcemptionCertificate: any, schema) => {
      if (qualifyExcemptionCertificate == 1) {
        return schema.required("State of residence is a required field")
      }
      return schema.nullable();

    }),
    qualifyNonresidentMilitarySpouseExcemption: yup
      .string()
      .nullable(),
    workInKentucky: yup
      .string()
      .nullable(),

    additionalWithholding: yup
      .string()
      .nullable(),
    martialstatus: yup.string().required("Martial status is a required field")
  })
  const { loading, postkyonline } = useFormsStore()
  const initializestore = useInitializeStore()
  const personalstore = usePersonalStore()
  return (
    <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader
            navLabel="Forms"
            navScreen="OnboardingForms"
            title={'KY Withholding Taxation'}
          />
        </View>
      </View>
      <View style={globalStyles.containerOverlap}>
        <Formik
          initialValues={{ ...intialValues }}
          validationSchema={alschema}
          onSubmit={async (values, actions) => {
            const data = {
              essUserOnBoardingFormKey: essUserOnBoardingFormKey,
              essObKey: essUserOnBoardingKey,
              completeOnline: mode === 'upload' ? false : true,
              essUserKey: initializestore.initializeData.userkey,
              entityId: personalstore.personalData?.entityId,
              incomeTaxLiabilityExpected: Number(values.incomeTaxLiabilityExpected) == 0 ? false : true,
              qualifyExcemptionCertificate: Number(values.qualifyExcemptionCertificate) == 0 ? false : true,
              stateOfResident: values?.stateOfResident ? values.stateOfResident : null,
              nonresidentMilSpouseExcemption: Number(values.qualifyNonresidentMilitarySpouseExcemption) == 0 ? false : true,
              workInKentucky: Number(values.workInKentucky) == 0 ? false : true,
              additionalWithholding: values.additionalWithholding ? values.additionalWithholding : null,
              maritalStatus: values?.martialstatus
            }

            const response = await postkyonline(data)
            if (response?.success) {
              if (mode === 'online') {
                navigation.navigate('KyInformationonline', {
                  userId,
                  mode,
                  essUserOnBoardingKey,
                  essUserOnBoardingFormKey,
                  values,
                })
              } else {
                await Toast.show({
                  type: 'success',
                  position: 'bottom',
                  text1: response?.message,
                  visibilityTime: 3000,
                  autoHide: true,
                  topOffset: 60,
                  onHide: () => {
                    navigation.replace('OnboardingForms')
                  }
                })
              }
            } else {
              await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
              })
            }

          }}
        >
          {(props) => (
            <>
              <Card>

                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ width: '65%', justifyContent: 'center' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Martial Status *'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: "hidden" }}>
                    <SelectKeyValue
                      title="Martial Status"
                      options={options1}
                      selectedOption={mapSelectValue(
                        options1,
                        props.values.martialstatus
                      )}
                      onSelect={(option: any) => {
                        if (option == 1 || option == 3) {
                          props.setFieldValue('martialstatus', "S")

                        }
                        else {
                          props.setFieldValue('martialstatus', "M")

                        }

                      }}
                      textColor="primary"
                    />{props.touched.martialstatus && props.errors.martialstatus && (
                      <Text style={globalStyles.dangerAlert}>
                        {props.errors.martialstatus}
                      </Text>
                    )}

                  </View>
                </View>
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '50%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {
                        'Kentucky income tax liability is not expected this year '
                      }
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <SelectKeyValue
                      title=" Kentucky income tax liability is not expected this year"
                      options={options3}
                      selectedOption={mapSelectValue(
                        options3,
                        props.values.incomeTaxLiabilityExpected
                      )}
                      onSelect={(option: any) => {
                        const val = option - 1
                        props.setFieldValue('incomeTaxLiabilityExpected', val)
                        if (val === 1) {
                          props.setFieldValue('additionalWithholding', '')
                        }
                      }}
                      textColor="primary"
                    />
                    {props.touched.incomeTaxLiabilityExpected &&
                      props.errors.incomeTaxLiabilityExpected && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.incomeTaxLiabilityExpected}
                        </Text>
                      )}
                  </View>
                </View>
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '50%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {
                        'You qualify for the Fort Campbell Exemption Certificate'
                      }
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <SelectKeyValue
                      title="You qualify for the Fort Campbell Exemption Certificate"
                      options={options3}
                      selectedOption={mapSelectValue(
                        options3,
                        props.values.qualifyExcemptionCertificate
                      )}
                      onSelect={(option: any) => {
                        const val = option - 1
                        props.setFieldValue('qualifyExcemptionCertificate', val)
                        if (val === 1) {
                          props.setFieldValue('additionalWithholding', '')
                        }
                      }}
                      textColor="primary"
                    />

                    {props.touched.qualifyExcemptionCertificate &&
                      props.errors.qualifyExcemptionCertificate && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.qualifyExcemptionCertificate}
                        </Text>
                      )}
                  </View>
                </View>


                {Number(props.values.qualifyExcemptionCertificate) == 1 &&
                  props.values.qualifyExcemptionCertificate != null && (
                    <View
                      style={[
                        globalStyles.hDirection,
                        globalStyles.hBetweenItems,
                        globalStyles.mb2
                      ]}
                    >
                      <View style={{ justifyContent: 'center', width: '50%' }}>
                        <Text
                          style={[
                            globalStyles.inputLabel,
                            globalStyles.inputLabelLarge,
                            globalStyles.inputLabelPrimary
                          ]}
                        >
                          {'Enter state of residence *'}
                        </Text>
                      </View>
                      <View style={{ width: '28%', overflow: 'hidden' }}>
                        <TextInput
                          style={[globalStyles.input, globalStyles.inputLight]}
                          value={props.values.stateOfResident}
                          onChangeText={(text) => {
                            props.handleChange('stateOfResident')(text)
                          }}
                        />
                        {props.touched.stateOfResident &&
                          props.errors.stateOfResident && (
                            <Text style={globalStyles.dangerAlert}>
                              {props.errors.stateOfResident}
                            </Text>
                          )}
                      </View>
                    </View>
                  )}


                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '50%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {
                        'You qualify for the nonresident military spouse exemption '
                      }
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <SelectKeyValue
                      title={
                        'You qualify for the nonresident military spouse exemption'
                      }
                      options={options3}
                      selectedOption={mapSelectValue(
                        options3,
                        props.values.qualifyNonresidentMilitarySpouseExcemption
                      )}
                      onSelect={(option: any) => {
                        const val = option - 1
                        props.setFieldValue('qualifyNonresidentMilitarySpouseExcemption', val)
                        if (val === 1) {
                          props.setFieldValue('additionalWithholding', '')
                        }
                      }}
                      textColor="primary"
                    />
                    {props.touched.qualifyNonresidentMilitarySpouseExcemption &&
                      props.errors
                        .qualifyNonresidentMilitarySpouseExcemption && (
                        <Text style={globalStyles.dangerAlert}>
                          {
                            props.errors
                              .qualifyNonresidentMilitarySpouseExcemption as string
                          }
                        </Text>
                      )}
                  </View>
                </View>

                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '50%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {
                        'You work in Kentucky and reside in a reciprocal state'
                      }
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <SelectKeyValue
                      title={
                        'You work in Kentucky and reside in a reciprocal state'
                      }
                      options={options3}
                      selectedOption={mapSelectValue(
                        options3,
                        props.values.workInKentucky
                      )}
                      onSelect={(option: any) => {
                        const val = option - 1
                        props.setFieldValue('workInKentucky', val)
                        if (val === 1) {
                          props.setFieldValue('additionalWithholding', '')
                        }
                      }}
                      textColor="primary"
                    />
                    {props.touched.workInKentucky &&
                      props.errors.workInKentucky && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.workInKentucky as string}
                        </Text>
                      )}
                  </View>
                </View>




                {Number(props.values.incomeTaxLiabilityExpected) !== 1 &&
                  Number(props.values.qualifyExcemptionCertificate) !== 1 &&
                  Number(props.values.qualifyNonresidentMilitarySpouseExcemption) !== 1 &&
                  Number(props.values.workInKentucky) !== 1 && (
                    <View
                      style={[
                        globalStyles.hDirection,
                        globalStyles.hBetweenItems,
                        globalStyles.mb2
                      ]}
                    >
                      <View style={{ justifyContent: 'center', width: '50%' }}>
                        <Text
                          style={[
                            globalStyles.inputLabel,
                            globalStyles.inputLabelLarge,
                            globalStyles.inputLabelPrimary
                          ]}
                        >
                          {
                            'Additional withholding per pay period under agreement with employer '
                          }
                        </Text>
                      </View>
                      <View style={{ width: '28%', overflow: 'hidden' }}>
                        <TextInput
                          keyboardType='numeric'
                          style={[globalStyles.input, globalStyles.inputLight]}
                          value={props.values.additionalWithholding}
                          onChangeText={(text) => {
                            if (text === '' || /^\d+$/.test(text)) {
                              props.handleChange('additionalWithholding')(text)
                            }
                          }}
                        />
                        {props.touched.additionalWithholding &&
                          props.errors.additionalWithholding && (
                            <Text style={globalStyles.dangerAlert}>
                              {props.errors.additionalWithholding as string}
                            </Text>
                          )}
                      </View>
                    </View>
                  )}

                {loading ? (
                  <ActivityIndicator />
                ) : (
                  <View style={{ margin: 10 }}>
                    <CustomButton
                      text={mode === 'upload' ? 'Submit Information' : 'Next'}
                      onPress={props.handleSubmit}
                    />
                  </View>
                )}
              </Card>
            </>
          )}
        </Formik>
      </View>

    </KeyboardAwareScrollView>
  )
}
export default KyInformationForm
